import { render, staticRenderFns } from "./BconnFileUploader.vue?vue&type=template&id=455fe996&scoped=true&"
import script from "./BconnFileUploader.vue?vue&type=script&lang=js&"
export * from "./BconnFileUploader.vue?vue&type=script&lang=js&"
import style0 from "./BconnFileUploader.vue?vue&type=style&index=0&id=455fe996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455fe996",
  null
  
)

export default component.exports